import { City } from "../models/cities.model";
import { ListItem } from "../models/ListItem";
import GenericService from "./genericService";
import { httpService } from "./httpService";

interface SearchCitiesResponse {
  items: ListItem[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
}

class CitiesService extends GenericService<City, ListItem> {
  constructor() {
    super("/api/Cities");
  }

  async getByStateId(id: number | string): Promise<City[]> {
    return await httpService.get<City[]>(
      `/api/Cities/GetByStateId/${id}`,
      undefined,
      { unwrap: true, normalize: true, toast: false }
    );
  }

  async searchCities(
    search?: string,
    stateId?: number,
    countryId: number = 101, // Default to India (country ID 101)
    page: number = 1,
    pageSize: number = 20
  ): Promise<SearchCitiesResponse> {
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    if (stateId) params.append("stateId", stateId.toString());
    if (countryId) params.append("countryId", countryId.toString());
    params.append("page", page.toString());
    params.append("pageSize", pageSize.toString());

    return await httpService.get<SearchCitiesResponse>(
      `/api/Cities/SearchCities?${params.toString()}`,
      undefined,
      { unwrap: true, normalize: true, toast: false }
    );
  }
}
export const citiesService = new CitiesService();
